import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FunctionsService } from '../../../___LOGIC/__common/functions.service';
import { DynamicCrudService } from 'src/app/___LOGIC/__crud/dynamic-crud.service';

@Component({
  selector: 'app-dynamic-date-picker',
  templateUrl: './dynamic-date-picker.component.html',
  styleUrls: ['./dynamic-date-picker.component.css']
})
export class DynamicDatePickerComponent implements OnInit {

    @Input() data;
    @Output() public dataOut = new EventEmitter();
    // GUI Values
    inputValue; // needed to change selection format 
    editMode = false;
    shortDate;
  
    constructor(private dynamicCrudService: DynamicCrudService,private commonFunctions: FunctionsService) { }
  
    ngOnInit(): void {
      if(this.data){
        this.data.value? null : this.data.value = null;
        this.data.columnName? null : this.data.columnName = '';
      }
    }

    onDateChange(e){
      this.data.value = e.target.value;
      this.dataOut.emit(this.data);
      this.editMode = !this.editMode;
    }
  
    switchEditingMode(){
      this.editMode = !this.editMode;
      this.editMode? this.dynamicCrudService.setCurrentFieldToEdit(this.data.columnName): null;
    }

    isEditMode(){
      return this.editMode && this.dynamicCrudService.isCurrentFieldEditing(this.data.columnName);
    }

    isDateEmpty(){
      return this.commonFunctions.isDateEmpty(this.data.value);
    }

    getDateToRender(){
      if(this.dynamicCrudService.getCurrentStatus() == 'update'){
        if(this.commonFunctions.isDateEmpty(this.data.value)){
          this.shortDate = '0000-00-00';
        }else{
          const parsedDate = new Date(this.data.value);
          // Check if the parsed date is invalid
          if (isNaN(parsedDate.getTime())) {
            this.shortDate = ''; // Return empty string for invalid dates
          } else {
            this.shortDate = parsedDate.toLocaleDateString('en-GB'); // Convert valid date
          }
          return this.shortDate;
        }
      }else{
        return this.shortDate;
      }
    }

  }